// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc7129f9","239":"5c45bb54","455":"7ff34595"}[chunkId] + ".chunk.js";
};